/**
 * ProductDetails - product description/details accordion area.
 * Custom element: <product-details>
 *
 * Refs:
 *   [data-ref="description"]  (required)
 *   [data-ref="readMore"]  (required)
 *   [data-ref="moreText"]  (required)
 *   [data-ref="lessText"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ProductDetails extends ThemeComponent {
  init() {
    this.removeReadMore(), this.$listen(this.readMore, "click", () => {
      this.RemoveTruncate();
    });
  }
  removeReadMore() {
    this.description.innerText.length >= 5 && this.readMore.classList.remove("visually-hidden");
  }
  RemoveTruncate() {
    this.description.classList.toggle("product-details__block--truncate"), this.moreText.classList.toggle("visually-hidden"), this.lessText.classList.toggle("visually-hidden");
  }
}
setFunctionName(ProductDetails, "ProductDetails");
const propertyTypes = {};
ProductDetails.prototype.$name = "ProductDetails";
ProductDetails.prototype.$info = JSON.parse('{"name":"ProductDetails","meta":{"isLegacy":false,"selector":"product-details"},"props":[],"refs":[{"selector":"[data-ref=\\"description\\"]","required":true,"propertyKey":"description","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"readMore\\"]","required":true,"propertyKey":"readMore","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"moreText\\"]","required":true,"propertyKey":"moreText","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLSpanElement"},{"selector":"[data-ref=\\"lessText\\"]","required":true,"propertyKey":"lessText","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLSpanElement"}]}');
ProductDetails.prototype.$info.component = ProductDetails;
for (const prop of ProductDetails.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductDetails.ts", {
  ProductDetails: ProductDetails
}, void 0);